<ng-container *transloco="let t">
  <div
    class="d-flex justify-content-between"
    [ngClass]="{ 'ms-2': question().repeaterId !== undefined }"
  >
    <button
      vinnova-button-text
      type="button"
      size="small"
      class="question-link"
      (click)="
        goToQuestion.emit({
          questionId: question().id,
          sectionId: sectionId(),
          repeaterId: question().repeaterId,
        })
      "
      [attr.aria-label]="
        t('aside_validation_question_label', {
          question: question().title,
        })
      "
    >
      {{ question().title }}
    </button>
    <span class="validation-message">
      @if (question().isRequiredFailed) {
        <span>{{ t('aside_validation_not_filled_in') }}</span>
      } @else {
        <span>{{ t('aside_validation_format_error') }}</span>
      }
      <lib-icon
        name="x-circle"
        class="validation-icon"
        size="small"
        aria-hidden="true"
      ></lib-icon>
    </span>
  </div>
</ng-container>
